"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPriceBooksQuery = exports.GetPriceBooksResponse = exports.GetPriceBookResponse = exports.GetPriceBookQuery = exports.GetPriceBookRequest = exports.CreatePriceBookResponse = exports.CreatePriceBookRequest = exports.UnitType = void 0;
const zod_1 = require("zod");
var UnitType;
(function (UnitType) {
    UnitType["UNIT"] = "UNIT";
    UnitType["METER"] = "METER";
    UnitType["HOUR"] = "HOUR";
    UnitType["DAY"] = "DAY";
    UnitType["SQUARE_METER"] = "SQUARE_METER";
    UnitType["CUBIC"] = "CUBIC";
    UnitType["INCH"] = "INCH";
    UnitType["FOOT"] = "FOOT";
    UnitType["SQUARE_FOOT"] = "SQUARE_FOOT";
})(UnitType || (exports.UnitType = UnitType = {}));
exports.CreatePriceBookRequest = zod_1.z.object({
    name: zod_1.z.string(),
    unit: zod_1.z.nativeEnum(UnitType),
    price: zod_1.z.number(),
    wholesalePrice: zod_1.z.number().optional(),
    notes: zod_1.z.string().optional(),
    previousVersionId: zod_1.z.string().optional(),
    quoteId: zod_1.z.string().optional(),
});
exports.CreatePriceBookResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
exports.GetPriceBookRequest = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.GetPriceBookQuery = zod_1.z.object({
    disabled: zod_1.z.boolean().optional(),
});
exports.GetPriceBookResponse = zod_1.z.object({
    id: zod_1.z.string(),
    createdBy: zod_1.z.string(),
    name: zod_1.z.string(),
    unit: zod_1.z.string(),
    price: zod_1.z.number(),
    wholesalePrice: zod_1.z.number().optional(),
    notes: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    updatedAt: zod_1.z.string().datetime(),
});
exports.GetPriceBooksResponse = zod_1.z.object({
    data: zod_1.z.array(exports.GetPriceBookResponse),
});
exports.GetPriceBooksQuery = zod_1.z.object({
    name: zod_1.z.string().optional(),
    unit: zod_1.z.string().optional(),
});
